import { apiMethod } from '../../shared';
import { APINames } from 'src/shared';
import { getDataType, reportErrorLog } from '../utils';
const apiName = 'onScreenRecordingStateChanged';

// 监听用户录屏事件
export function onScreenRecordingStateChanged(listener: Function) {
  if (getDataType(listener) !== 'Function') {
    reportErrorLog(apiName, 'callback is not a function');
    return;
  }
  apiMethod.on(APINames.Native.ON_SCREEN_RECORD_STATE_CHANGE, listener);
}
